module.exports = __webpack_public_path__ + "static/media/gn.08eac752.svg";